module.exports = __webpack_public_path__ + "static/img/76023K_2_C_20200123_LC.2429e9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76023K_2_C_20200123_LC.png
// module id = ym5S
// module chunks = 0